<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'
import GLayout from './components/GLayout.vue'

const auth = useAuthStore()

onMounted(() => {
	if (auth.loading) {
		auth.fetchMe()
	}
})
</script>

<template>
	<GLayout>
		<RouterView />
	</GLayout>
</template>
